export enum Modal {
	CustomerSupport = "CustomerSupport",
	PrivacyPolicy = "PrivacyPolicy",
	TermsOfService = "TermsOfService",
	SurfGuide = "SurfGuide",
}
